import { LIST_TYPES } from "../utils/listTypes";

import ScrollList from "./ScrollList";

const CaseStatusDashFilter = ({ caseStatusCounts }) => {
  return (
    <div
      id="Case-Status-Dashboard-Filter"
      data_testid="Case-Status-Dashboard-Filter"
      className="overflow-y-auto"
    >
      <ScrollList array={caseStatusCounts} type={LIST_TYPES.BUTTON_LIST} />
    </div>
  );
};

export default CaseStatusDashFilter;
